import React, {useEffect, useState} from 'react';
import api from '../services/api';
import '../styles/ProjectPage.css';
import ProjectModal from '../modals/ProjectModal';
import ProjectDetails from './ProjectDetails';
import {getProjectEntries} from '../services/ProjectServices';


export default function ProjectPage() {
    const [projects, setProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [editProject, setEditProject] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        loadProjects();
    }, []);

    const loadProjects = async () => {
        try {
            const projects = await getProjectEntries();
            setProjects(projects);
        } catch (err) {
            console.error('Failed loading users', err);
        }
    };

    const handleProjectClick = (project) => {
        setSelectedProject(project);
    };

    const handleAddProject = () => {
        setEditProject(null);
        setShowModal(true);
    };

    const handleEditProject = () => {
        setEditProject(selectedProject);
        setShowModal(true);
    };

    const handleDeleteProject = () => {
        if (window.confirm("Delete this project?")) {
            api.delete(`/project/${selectedProject.id}`).then(() => {
                loadProjects();
                setSelectedProject(null);
            });
        }
    };

    const handleModalSave = () => {
        setShowModal(false);
        loadProjects();
    };

    const filteredProjects = projects.filter(p =>
        (p.name && p.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (p.companyName && p.companyName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (p.customerName && p.customerName.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    return (
        <div className="project-page">
            <div className="project-list-panel">
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <h3>Projekte</h3>
                    <button className="button" onClick={handleAddProject}>
                        Projekt hinzufügen
                    </button>
                </div>

                <input
                    type="text"
                    placeholder="Projekt suchen..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="project-search"
                />

                {filteredProjects.map(p => (
                    <div
                        key={p.id}
                        className={`project-item ${selectedProject?.id === p.id ? 'active' : ''}`}
                        onClick={() => handleProjectClick(p)}>
                        {p.companyName}: {p.name}
                    </div>
                ))}
            </div>

            <div className="project-details-panel">
                {selectedProject ? (
                    <>
                        <h2>{selectedProject.name}</h2>
                        <p><strong>Beschreibung:</strong> {selectedProject.description}</p>
                        <p><strong>Kunde:</strong> {selectedProject.companyName}</p>

                        <div style={{marginTop: '20px', display: 'flex', gap: '10px'}}>
                            <button className="button" onClick={handleEditProject}>Anpassen</button>
                            <button className="button button-danger" onClick={handleDeleteProject}>Löschen</button>
                        </div>

                        <ProjectDetails project={selectedProject}/>
                    </>
                ) : (
                    <h3>Projekt auswählen...</h3>
                )}
            </div>

            {showModal && (
                <ProjectModal
                    customers={projects}
                    project={editProject}
                    onClose={() => setShowModal(false)}
                    onSave={handleModalSave}
                />
            )}
        </div>
    );
}
